import React from "react";
import "./Story.scss";
import ButtonRectangle from "../../UIComponents/ButtonRectangle/ButtonRectangle";
const Story = () => {
  return (
    <section className="stories">
      <div className="bg-video">
        <video className="bg-video-content" autoPlay muted loop>
          <source
            src="img/coverr-sunset-in-basel-7324-1080pCompressed.mp4"
            type="video/mp4"
          />
          your Browser Does NOT support this
        </video>
      </div>
      <div className="u-center-text u-margin-bottom-big">
        <h2 className="heading-secondary">
          Unveiling the Rich Tapestry of Switzerland's Stories
        </h2>
      </div>
      <div className="row">
        <div className="story u-margin-bottom-small">
          <figure className="story-shape">
            <img
              src="img/copyright-free-images-750x420.jpg"
              alt="a boat on the lake"
              className="story-image"
            />
            <figcaption className="story-caption"> Amelia Thompson</figcaption>
          </figure>
          <div className="story-text">
            <h3 className="heading-tertiary u-margin-buttom-small">
              i have had the best weak
            </h3>
            <p>
              Switzerland has undoubtedly left an indelible mark on my heart.
              Its beauty, tranquility, and warmth of its people have made it an
              unforgettable destination. Whether you seek adventure, relaxation,
              or simply a connection with nature, Switzerland is a place where
              dreams come true.
            </p>
          </div>
        </div>
        <div className="story">
          <figure className="story-shape">
            <img
              src="img/RickRickson.jpg"
              alt="a boat on the lake"
              className="story-image"
            />
            <figcaption className="story-caption"> Rick Johnson</figcaption>
          </figure>
          <div className="story-text">
            <h3 className="heading-tertiary u-margin-buttom-small">
              im a better man now
            </h3>
            <p>
              "In the heart of Basel, Switzerland, I found myself immersed in a
              harmonious blend of history, art, and natural beauty. The city's
              vibrant streets echoed with the footsteps of both locals and
              visitors, creating an atmosphere that felt truly alive. From the
              mesmerizing architecture of the Old Town to the world-class
              museums and galleries, Basel bewitched me with its cultural
              richness.
            </p>
          </div>
        </div>
        <div className="u-center-text">
          <ButtonRectangle href="#popup" text={"read more"} />
        </div>
      </div>
    </section>
  );
};

export default Story;
